export default "__VITE_ASSET__2fec1e32__"